import { render, staticRenderFns } from "./CardStatistics.vue?vue&type=template&id=af0e4ca6&"
import script from "./CardStatistics.vue?vue&type=script&lang=js&"
export * from "./CardStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports